document.addEventListener('DOMContentLoaded', function() {
  // State object to track filters
  const state = {
    collection: '{{ collection.handle }}' || 'all',
    filters: [], // Will store filter segments like ['mens-wear-t-shirt', '10-20']
    sort: '{{ collection.sort_by }}' || 'manual',
    page: 1
  };

  // Price filter mappings
  const priceFilterMappings = {
    '$10 to $20': '10-20',
    '$20 to $50': '20-50',
    '$21 to $50': '21-50',
    '$50 to $100': '50-100',
    '$51 to $100': '51-100',
    '$100 to $150': '100-150',
    '$101 to $200': '101-200',
    '$150 to $200': '150-200',
    '$200 to $250': '200-250',
    '$250 to $300': '250-300',
    '$300 to $350': '300-350',
    '$350 to $400': '350-400',
    '$400 to $450': '400-450',
    '$450 to $500': '450-500',
    '$500 to $1,000': '500-1000',
    '$501 to $1000': '501-1000',
    '$1 to $10000': '1-10000',
    '$1,000 to $1,500': '1000-1500',
    '$1,500 to $2,000': '1500-2000',
    '$2,000 to $2,500': '2000-2500',
    '$2,500 to $3,000': '2500-3000',
    '$3,000 to $3,500': '3000-3500',
    '$3,500 to $4,000': '3500-4000',
    '$4,000 to $4,500': '4000-4500',
    '$4,500 to $5,000': '4500-5000',

    // Open-ended ranges
    'Above $1001': 'over-1001',
    'Above $600': 'over-600',
    'Over $5,000': 'over-5000',
    'Under $50': 'under-50',
    'over-$100': 'over-100' // Keeping this for backward compatibility
  };

  // Sync select filters with state
  function syncFiltersWithState() {
    console.log('Syncing filters with state:', state);
    
    // Update Category filter
    const categoryVal = state.collection === 'all' ? 'all' : state.collection;
    $('#CategoryFilter').val($('#CategoryFilter option[value="' + categoryVal + '"]').length ? categoryVal : 'all');
    if ($('#CategoryFilter').hasClass('nice-select')) {
      $('#CategoryFilter').niceSelect('update');
    }
    
    // Update other filters based on state.filters
    const currentFilters = state.filters;
    
    // Extract vendor/brand filter
    const brandFilter = currentFilters.find(filter => 
      filter.includes('callaway') || filter.includes('titleist') || filter.includes('taylormade')
    );
    $('#BrandFilter').val(brandFilter ? brandFilter.replace(/-/g, ' ') : '');
    if ($('#BrandFilter').hasClass('nice-select')) {
      $('#BrandFilter').niceSelect('update');
    }
    
    // Extract gender filter
    const genderFilter = currentFilters.find(filter => 
      filter.includes('mens-wear') || filter.includes('ladies-wear')
    );
    $('#GenderFilter').val(genderFilter ? 
      (genderFilter.includes('mens-wear') ? 'Men' : 'Women') : '');
    if ($('#GenderFilter').hasClass('nice-select')) {
      $('#GenderFilter').niceSelect('update');
    }
    
    // Extract price filter
    const priceFilter = currentFilters.find(filter => 
      filter.includes('-') && (filter.match(/\d+-\d+/) || filter === 'over-100')
    );
    
    // Convert URL price format back to select option value
    let priceSelectValue = '';
    if (priceFilter) {
      if (priceFilter === 'over-100') {
        priceSelectValue = 'over-$100';
      } else {
        // Find matching price option
        for (const [option, urlValue] of Object.entries(priceFilterMappings)) {
          if (urlValue === priceFilter) {
            priceSelectValue = option;
            break;
          }
        }
        
        // If no match found in predefined options, check custom price collections
        if (!priceSelectValue) {
          priceSelectValue = priceFilter.replace(/-/g, ' - ');
        }
      }
    }
    $('#PriceFilter').val(priceSelectValue);
    if ($('#PriceFilter').hasClass('nice-select')) {
      $('#PriceFilter').niceSelect('update');
    }
    
    // Update sort
    $('#SortBy').val(state.sort);
    if ($('#SortBy').hasClass('nice-select')) {
      $('#SortBy').niceSelect('update');
    }
    
    // Update reset button state
    updateResetButtonState();
  }

  // Update reset button disabled state
  function updateResetButtonState() {
    const hasFilters = state.filters.length > 0 || state.sort !== 'manual';
    $('#ResetFilters').prop('disabled', !hasFilters)
                      .toggleClass('disabled', !hasFilters);
  }

  // Parse filters from current URL
  function parseCurrentFilters() {
    const url = new URL(window.location.href);
    const pathParts = url.pathname.split('/');
    
    // Extract collection handle
    const collectionsIndex = pathParts.indexOf('collections');
    if (collectionsIndex > -1 && collectionsIndex + 1 < pathParts.length) {
      state.collection = pathParts[collectionsIndex + 1];
    } else {
      state.collection = 'all';
    }
    
    // Extract filters from URL path
    state.filters = [];
    if (collectionsIndex > -1 && collectionsIndex + 2 < pathParts.length) {
      // Decode URI component and clean up price filters
      const filterSegment = decodeURIComponent(pathParts[collectionsIndex + 2])
        .replace(/\$+/g, '') // Remove dollar signs
        .replace(/\s*\+\s*/g, '+') // Clean up + signs
        .replace(/\s*-\s*/g, '-'); // Clean up - signs
      
      state.filters = filterSegment.split('+');
    }
    
    // Extract sort parameter
    state.sort = url.searchParams.get('sort_by') || 'manual';
    state.page = parseInt(url.searchParams.get('page')) || 1;
    
    console.log('Parsed State:', state);
  }

  // Update browser URL with filters in path and sort as query param
  function updateBrowserURL() {
    let urlPath = `/collections/${state.collection}`;
    
    // Add filters to path if any
    if (state.filters.length > 0) {
      // Clean up filters before adding to URL
      const cleanFilters = state.filters.map(filter => {
        // Handle price filters
        if (filter.includes('-') && (filter.match(/\d+-\d+/) || filter === 'over-100')) {
          return filter.replace(/\s+/g, '');
        }
        return filter;
      });
      urlPath += `/${cleanFilters.join('+')}`;
    }
    
    // Create new URL
    const url = new URL(window.location.origin + urlPath);
    
    // Add sort parameter if not default
    if (state.sort !== 'manual') {
      url.searchParams.set('sort_by', state.sort);
    }
    
    // Add page parameter if not first page
    if (state.page > 1) {
      url.searchParams.set('page', state.page);
    }
    
    window.history.pushState({}, '', url.toString());
    console.log('Updated URL:', url.toString());
  }

  // Fetch filtered products via AJAX
  async function fetchProducts() {
    const $productGrid = $('#product-grid');
    $productGrid.addClass('loading');

    try {
      // Build the URL with filters in path and sort as query param
      let apiUrl = `/collections/${state.collection}`;
      
      // Add filters to path if any
      if (state.filters.length > 0) {
        apiUrl += `/${state.filters.join('+')}`;
      }
      
      // Add view=ajax parameter for AJAX requests
      apiUrl += '?view=ajax';
      
      // Add sort parameter if not default
      if (state.sort !== 'manual') {
        apiUrl += `&sort_by=${state.sort}`;
      }
      
      // Add page parameter if not first page
      if (state.page > 1) {
        apiUrl += `&page=${state.page}`;
      }
      
      console.log('Fetching URL:', apiUrl);

      const response = await fetch(apiUrl);
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      const text = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');
      const productGrid = doc.querySelector('.collection-page__products-row-wrapper');
      const pagination = doc.querySelector('.pagination');

      const $container = $('.collection-page__products-row-wrapper');
      if (productGrid && productGrid.children.length > 0) {
        $container.html(productGrid.innerHTML);
      } else {
        console.log('No products found in response:', text);
        $container.html('<div class="no-products">No products match your selection.</div>');
      }

      const $pagination = $('.pagination');
      if (pagination) {
        $pagination.html(pagination.innerHTML);
      } else {
        $pagination.html('');
      }

      updateBrowserURL();
      initProductCards();
    } catch (error) {
      console.error('Fetch error:', error);
      $('.collection-page__products-row-wrapper').html('<div class="error">Error loading products. Please try again.</div>');
    } finally {
      $productGrid.removeClass('loading');
      syncFiltersWithState();
    }
  }

  // Reinitialize product interactions after AJAX
  function initProductCards() {
    if (typeof window.initProductQuickView === 'function') {
      window.initProductQuickView();
    }
    if (typeof window.initProductVariants === 'function') {
      window.initProductVariants();
    }
  }

  // Format price filter value for URL
  function formatPriceFilterValue(value) {
    if (!value) return null;
    
    // Check if it's a predefined price range
    if (priceFilterMappings[value]) {
      return priceFilterMappings[value];
    }
    
    // Handle custom price ranges (from collections)
    return value.replace(/\$/g, '')      // Remove dollar signs
                .replace(/\s*to\s*/g, '-') // Replace "to" with hyphen
                .replace(/\s+/g, '');     // Remove all spaces
  }

  // Handle price filter changes
  function handlePriceFilterChange(value) {
    const urlValue = formatPriceFilterValue(value);
    
    // Remove any existing price filter
    state.filters = state.filters.filter(f => 
      !(f.includes('-') && (f.match(/\d+-\d+/) || f === 'over-100'))
    );
    
    // Add new filter if value exists
    if (urlValue) {
      state.filters.push(urlValue);
    }
    
    state.page = 1;
    fetchProducts();
  }

  // Helper functions to identify filter types
  function isBrandFilter(filter) {
    return filter.includes('callaway') || filter.includes('titleist') || filter.includes('taylormade');
  }

  function isGenderFilter(filter) {
    return filter.includes('mens-wear') || filter.includes('ladies-wear');
  }

  function isPriceFilter(filter) {
    return filter.includes('-') && (filter.match(/\d+-\d+/) || filter === 'over-100');
  }

  // Initialize event listeners
  function initEventListeners() {
    // Category filter - full page load
    $('#CategoryFilter').off('change.theme').on('change.custom', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const value = $(this).val();
      if (value === 'all') {
        window.location.href = '/collections/all';
      } else {
        window.location.href = `/collections/${value}`;
      }
    });

    // Brand filter
    $('#BrandFilter').off('change.theme').on('change.custom', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const value = $(this).val();
      const urlValue = value.toLowerCase().replace(/\s+/g, '-');
      
      // Remove existing brand filter
      state.filters = state.filters.filter(f => !isBrandFilter(f));
      
      // Add new filter if value exists
      if (urlValue) {
        state.filters.push(urlValue);
      }
      
      state.page = 1;
      fetchProducts();
    });

    // Gender filter
    $('#GenderFilter').off('change.theme').on('change.custom', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const value = $(this).val();
      const urlValue = value.toLowerCase().includes('men') ? 'mens-wear' : 'ladies-wear';
      
      // Remove existing gender filter
      state.filters = state.filters.filter(f => !isGenderFilter(f));
      
      // Add new filter if value exists
      if (urlValue) {
        state.filters.push(urlValue);
      }
      
      state.page = 1;
      fetchProducts();
    });

    // Price filter
    $('#PriceFilter').off('change.theme').on('change.custom', function(e) {
      e.preventDefault();
      e.stopPropagation();
      handlePriceFilterChange($(this).val());
    });

    // Sort filter
    $('#SortBy').off('change.theme').on('change.custom', function(e) {
      e.preventDefault();
      e.stopPropagation();
      state.sort = $(this).val();
      state.page = 1;
      fetchProducts();
    });

    // Reset filters
    $('#ResetFilters').off('click.theme').on('click.custom', function(e) {
      if ($(this).hasClass('disabled')) return;
      e.preventDefault();
      e.stopPropagation();
      state.filters = [];
      state.sort = 'manual';
      state.page = 1;
      fetchProducts();
    });

    // Pagination click
    $(document).off('click.theme', '.pagination a').on('click.custom', '.pagination a', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const url = new URL($(this).attr('href'));
      state.page = parseInt(url.searchParams.get('page')) || 1;
      fetchProducts();
      window.scrollTo({ top: $('#product-grid').offset().top - 100, behavior: 'smooth' });
    });

    // Handle browser history navigation
    window.addEventListener('popstate', function(e) {
      e.preventDefault();
      parseCurrentFilters();
      syncFiltersWithState();
      fetchProducts();
    });
  }

  // Initialize
  parseCurrentFilters();
  initEventListeners();
  fetchProducts().then(() => {
    if (typeof $.fn.niceSelect !== 'undefined') {
      $('.collection-filter select, #SortBy').each(function() {
        if (!$(this).hasClass('nice-select')) {
          $(this).niceSelect();
        }
      });
      console.log('niceSelect initialized for filters');
    }
  });
});